import { configureStore } from '@reduxjs/toolkit';
import ayahReducer from './slices/ayahSlice';
import recitationReducer from './slices/recitationSlice';
import evaluationReducer from './slices/evaluationSlice';
import subscriptionReducer from './slices/subscriptionSlice';
import liveSessionReducer from './slices/liveSessionSlice';

export const store = configureStore({
  reducer: {
    ayah: ayahReducer,
    recitation: recitationReducer,
    evaluation: evaluationReducer,
    subscription: subscriptionReducer,
    liveSession: liveSessionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['recitation.audioBlob'],
        ignoredActions: ['recitation/setAudioBlob'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
